import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

import { sendClickAnaliticsEvent } from 'Analitics'
import { DownloadIcon } from 'Icons'

export default function DownloadButton() {
  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    const id = event.currentTarget.id
    if (id) {
      sendClickAnaliticsEvent(id)
    }
  }, [])

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      const activeElement = document?.activeElement
      if (activeElement instanceof HTMLElement) {
        activeElement.blur()
      }
      handleClick(event)
    },
    [handleClick],
  )

  return (
    <div id="download-button" onClick={handleClick} className="dropdown dropdown-top">
      <button tabIndex={0} className="btn btn-sm font-sans dark:hover:bg-slate-950">
        <DownloadIcon />
        <FormattedMessage id="buttons.downloadPDF" defaultMessage="Download PDF" />
      </button>
      <ul
        tabIndex={0}
        className="menu dropdown-content bg-base-100 rounded-box z-1 mb-1 w-52 p-2 shadow-sm"
      >
        <li>
          <a id="download-color" href="/EmotionWheel-color.pdf" target="_blank" onClick={onClick}>
            <FormattedMessage id="buttons.downloadPDF.colored" defaultMessage="Download (Color)" />
          </a>
        </li>
        <li>
          <a
            id="download-black-and-white"
            href="/EmotionWheel-black-and-white.pdf"
            target="_blank"
            onClick={onClick}
          >
            <FormattedMessage
              id="buttons.downloadPDF.blackAndWhite"
              defaultMessage="Download (Black & White)"
            />
          </a>
        </li>
      </ul>
    </div>
  )
}
